import { createFileRoute } from '@tanstack/react-router';

import { ForgotForm } from '@/features/auth/ForgotForm';

/** `/forgot-password` —— 申請重設密碼連結。 */
export const Route = createFileRoute('/forgot-password')({
  component: ForgotForm,
});
